import React from 'react';

import './buttons.styles.css';

interface IAppButtonsProps {
  className?: string;
  buttonType?: 'back' | 'default' | 'success' | 'warning';
  children: string | React.ReactNode;
  onClick?: any;
  block?: boolean;
  style?: React.CSSProperties;
}

const AppButton = ({
  buttonType,
  children,
  onClick,
  block,
  className,
  style,
}: IAppButtonsProps) => {
  return (
    <button
      className={`app-buttons ${buttonType} ${
        block ? 'app-buttons-block' : ''
      } ${className}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
};

AppButton.defaultProps = {
  buttonType: 'default',
  block: false,
  className: '',
};

export default AppButton;
